import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DashboardFacade } from '../store/dashboard.facade';

@Component({
  selector: 'app-emailbouncedwidget',
  templateUrl: './emailbouncedwidget.component.html',
  styleUrls: ['./emailbouncedwidget.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EmailbouncedwidgetComponent implements OnInit {

  public bouncedDocuments$ = this.dashboardFacade$.bouncedDocuments$;
  constructor(private dashboardFacade$: DashboardFacade) { }

  ngOnInit(): void {
    this.dashboardFacade$.fetchBouncedDocuments();
  }

}
